import React from "react";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

import { Footer } from "@jobmatchme/ui";
import Header from "./Header/";

import "./all.scss";

import appleTouchIcon from "../img/apple-touch-icon.png";
import favicon16 from "../img/favicon-16x16.png";
import favicon32 from "../img/favicon-32x32.png";
import safariPinnedTab from "../img/safari-pinned-tab.svg";
import { ThemeProvider, Section } from "@jobmatchme/ui";

const TemplateWrapper = ({ children, pathname }) => {
  return (
    <StaticQuery
      query={graphql`
        query HeadingQuery {
          site {
            siteMetadata {
              title
              description
            }
          }
        }
      `}
      render={data => (
        <div>
          <Helmet>
            <html lang="en" />
            <title>{data.site.siteMetadata.title}</title>
            <meta
              name="description"
              content={data.site.siteMetadata.description}
            />

            <link
              rel="apple-touch-icon"
              sizes="180x180"
              href={appleTouchIcon}
            />
            <link rel="icon" type="image/png" href={favicon32} sizes="32x32" />
            <link rel="icon" type="image/png" href={favicon16} sizes="16x16" />

            <link rel="mask-icon" href={safariPinnedTab} color="#ff4400" />
            <meta name="theme-color" content="#fff" />
            <meta property="og:type" content="business.business" />
            <meta property="og:title" content={data.site.siteMetadata.title} />
            <meta property="og:url" content="/" />
            <meta property="og:image" content="/img/og-image.jpg" />
            <script
              src="//cdn.mouseflow.com/projects/9f53439b-706b-4c9a-b7f7-ab004ed7c5af.js"
              async
            />
          </Helmet>
          <ThemeProvider variant="bc" subvariant="news">
            <Header />
            <div className="content-wrapper">
              <Section row={false}>{children}</Section>
            </div>
            <Footer />
          </ThemeProvider>
        </div>
      )}
    />
  );
};

export default TemplateWrapper;
